<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">实训耗材入库</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="耗材名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入耗材名称"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable
            :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
          <!-- <el-input v-model="formInline.training_room" clearable :placeholder="`请输入所属${$store.state.themeTitle}室`"></el-input> -->
        </el-form-item>
        <el-form-item label="校区">
          <el-input v-model="formInline.school_area" clearable placeholder="请输入校区"></el-input>
        </el-form-item>
        <el-form-item label="楼宇名称">
          <el-input v-model="formInline.building_name" clearable placeholder="请输入楼宇名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="校区">
          <el-select v-model="formInline.school_area" clearable filterable placeholder="请选择校区">
            <el-option v-for="item in $store.state.params.school_area" :key="item.school_area" :label="item.school_area"
              :value="item.school_area"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼宇名称">
          <el-select v-model="formInline.building_name" clearable filterable placeholder="请选择校区">
            <el-option v-for="item in $store.state.params.building_name" :key="item.building_name"
              :label="item.building_name" :value="item.building_name"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="地点">
          <el-input v-model="formInline.address" clearable placeholder="请输入地点"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训耗材导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle == '导出中...'" @click="handleExportByUrl(formInline)">{{
            exportTitle }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEditRoom">批量修改{{ $store.state.themeTitle }}室</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%"
        @selection-change="handleSelectionChange(...arguments, 'id')">
        <custom-table-column type="selection" width="40">
        </custom-table-column>
        <custom-table-column fixed prop="name" label="实训耗材名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="number" label="编号" width="120">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" min-width="160px">
        </custom-table-column>
        <!-- <custom-table-column prop="major" label="专业" min-width="160px">
        </custom-table-column> -->
        <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180px">
        </custom-table-column>
        <custom-table-column prop="warn_num" label="预警阈值" width="100">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="grade" label="年级" width="100">
        </custom-table-column>
        <custom-table-column prop="type2" label="类别" width="150">
        </custom-table-column>
        <custom-table-column prop="type" label="类型" width="150">
        </custom-table-column>
        <custom-table-column prop="quantity" label="数量" width="120">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="100">
        </custom-table-column>
        <custom-table-column prop="remainder_quantity" label="库存数量" width="120">
        </custom-table-column>
        <custom-table-column prop="price" label="价格" width="150">
        </custom-table-column>
        <custom-table-column prop="total_price" label="总价" width="180">
        </custom-table-column>
        <custom-table-column prop="fx_level" label="风险等级" width="100">
        </custom-table-column>
        <custom-table-column prop="school_area" label="校区" width="180px">
        </custom-table-column>
        <custom-table-column prop="building_name" label="楼宇名称" width="180px">
        </custom-table-column>
        <custom-table-column prop="supplier" label="销售商" width="150">
        </custom-table-column>
        <custom-table-column prop="address" label="地点" width="150">
        </custom-table-column>
        <custom-table-column prop="manufacturer" label="制造商" width="150">
        </custom-table-column>
        <custom-table-column prop="usage" label="使用方向" width="150">
        </custom-table-column>
        <custom-table-column prop="place" label="存放地点" width="150">
        </custom-table-column>
        <custom-table-column prop="size" label="规格" width="150">
        </custom-table-column>
        <custom-table-column prop="cc_number" label="出厂编号" width="150">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" width="220">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="120">
        </custom-table-column>
        <custom-table-column prop="buy_at" label="购买时间" width="160">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button @click="handleNumbeChange(scope.row.id)" type="text" size="small">库存修改</el-button>
            <el-button
              @click="handleEdit(scope.row, [], 'view')"
              type="text" size="small">详情</el-button>
            <el-button
              @click="handleEdit(scope.row, ['address', 'building_name', 'creator_id', 'school_area', 'created_at', 'deleted_at', 'creator_name', 'creator_user_name','fx_updated_at'], 'edit')"
              type="text" size="small">编辑</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-tag size="mini" type="warning"
        style="margin-bottom: 8px;margin-left:32px;">耗材编码规则：学年代码+学期代码+系部代码+专业代码+序列号，示例2310102002</el-tag>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :disabled="type == 'view'"  class="demo-ruleForm">
        <el-form-item label="耗材编号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="耗材名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入实训耗材名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="单 位" prop="unit">
          <el-input v-model="ruleForm.unit" placeholder="请输入单位" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="`所属${$store.state.themeTitle}室`" prop="training_room">
          <el-input v-model="ruleForm.training_room" :placeholder="`请输入所属${$store.state.themeTitle}室`" style="width:216px;"></el-input>
        </el-form-item> -->

        <el-form-item label="组织结构" prop="structure_1">
          <el-input v-model="selectName" placeholder="请选择组织结构" style="width:532px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;"
            :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预警阈值" prop="warn_num">
          <el-input v-model.number="ruleForm.warn_num" placeholder="请输入预警阈值" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="类 别" prop="type2">
          <el-select v-model="ruleForm.type2" style="width:216px;" placeholder="请选择类别">
            <el-option v-for="item in $store.state.consumTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类  型" prop="type">
          <el-input v-model="ruleForm.type" placeholder="请输入类型" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" style="width:216px;" placeholder="请选择学年学期">
            <el-option v-for="item in $store.state.termms" :key="item.id" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年  级" prop="grade">
          <el-select v-model="ruleForm.grade" style="width:216px;" placeholder="请选择年级">
            <el-option v-for="item in $store.state.grades" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数  量" prop="quantity">
          <el-input v-model="ruleForm.quantity" placeholder="请输入数量" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="价  格" prop="price">
          <el-input v-model="ruleForm.price" placeholder="请输入价格" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="购买时间" prop="buy_at">
          <el-date-picker type="datetime" placeholder="选择购买时间" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.buy_at" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="总  价" prop="total_price">
          <el-input v-model="total_price" placeholder="请先输入数量和价格" :disabled="true" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="销售商" prop="supplier">
          <el-input v-model="ruleForm.supplier" placeholder="请输入销售商" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="制造商" prop="manufacturer">
          <el-input v-model="ruleForm.manufacturer" placeholder="请输入制造商" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="使用方向" prop="usage">
          <el-input v-model="ruleForm.usage" placeholder="请输入使用方向" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="存放地点" prop="place">
          <el-input v-model="ruleForm.place" placeholder="请输入存放地点" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="规  格" prop="size">
          <el-input v-model="ruleForm.size" placeholder="请输入规格" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="出厂编号" prop="cc_number">
          <el-input v-model="ruleForm.cc_number" placeholder="请输入出厂编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" placeholder="请输入备注" style="width:532px;"></el-input>
        </el-form-item>
        <!-- 物品风险评估 -->
        <div class="add_win ">
          <p class="add_win_title">AI风险评估 <span style="float:right;"><AiRiskAssessment :formData="ruleForm" apiUrl="api/v2/BdBce/runs?obj_type=haocai" nameField="name"
                :disabled="type == 'view'" /></span>
            </p>
          <div class="add_win_body el-form">
            <el-form-item label="风险等级" prop="fx_level">
              <el-select v-model="ruleForm.fx_level" placeholder="请选择风险等级" style="width:216px;" clearable>
                <el-option v-for="item in $store.state.dangerLevells" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="风险类型" prop="fx_type">
              <el-select v-model="ruleForm.fx_type" multiple placeholder="请选择风险类型" style="width:512px;" clearable>
                <el-option v-for="(item, index) in $store.state.dangerTypes" :key="index" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="存储要求" prop="fx_store">
              <el-input type="textarea" v-model="ruleForm.fx_store" placeholder="请输入存储要求" style="width:512px;"
                :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="个人防护要求" prop="fx_protection">
              <el-input type="textarea" v-model="ruleForm.fx_protection" placeholder="请输入个人防护要求" style="width:512px;"
                :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="应急处理措施" prop="fx_measure">
              <el-input type="textarea" v-model="ruleForm.fx_measure" placeholder="请输入应急处理措施" style="width:512px;"
                :rows="3"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="库存修改" :visible.sync="numberDialogVisible" width="406px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="类  型" prop="type">
          <el-select v-model="ruleForm1.type" style="width:216px;" placeholder="请选择类型">
            <el-option v-for="item in $store.state.mathMethods" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数  量" prop="num">
          <el-input v-model.number="ruleForm1.num" placeholder="请输入数量" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm1', changeConsumeNumber)">确认</el-button>
          <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="`批量修改${$store.state.themeTitle}室`" :visible.sync="dialogVisible1"
      width="400px">
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="type">
          <el-select v-model="ruleForm2.training_no" filterable style="width:216px;"
            :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange1">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="editTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData" printTitle="耗材入库"></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinPrint } from '@/assets/js/mixin/print';
import AiRiskAssessment from '@/components/AiRiskAssessment.vue';
export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinPrint],
  components: {
    AiRiskAssessment,
  },
  data() {
    return {
      formInline: {
        name: '',
        training_room: '',
        building_name: '',
        school_area: '',
        address: '',
        structure_1: '',
        major: '',
      },
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      ruleForm: {
        number: '',
        name: '',
        training_room: '',
        training_no: '',
        quantity: 0,
        warn_num: null,
        price: 0,
        total_price: 0,
        buy_at: '',
        supplier: '',
        manufacturer: '',
        type: '',
        usage: '',
        place: '',
        size: '',
        cc_number: '',
        desc: '',
        structure_1: '',
        major: '',
        type2: '',
        term: '',
        grade: '',
        unit: '',
        fx_level: '',
        fx_type: [],
        fx_store: '',
        fx_protection: '',
        fx_measure: '',
      },
      ruleForm1: {
        id: '',
        type: '',
        number: 0,
      },
      numberDialogVisible: false,
      dialogVisible1: false,
      ruleForm2: {
        id: '',
        training_no: '',
        training_room: '',
      },
      classRooms: [],
      rules: {
        number: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          // { validator: this.checkhcnum, trigger: 'blur' },
        ],
        type2: [{ required: true, message: '请选择类别', trigger: 'change' }],
        term: [{ required: true, message: '请选择学年学期', trigger: 'change' }],
        // grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
        structure_1: [{ required: true, message: '请选择组织结构' }],
        quantity: [
          { required: true, message: '数量不能为空' },{ validator: this.checkfloat, trigger: 'blur' }
        ],
        warn_num: [
          { type: 'number', message: '数量必须为数字值' },
        ],
        price: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        total_price: [
          { required: true, message: '请先输入数量和价格' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        name: [{ required: true, message: '请输入实训耗材名称', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入耗材单位', trigger: 'blur' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        training_no: [{ required: true, message: `请选择所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        buy_at: [{ required: true, message: '请选择购买时间', trigger: 'change' }],
      },
      rules2: {
        training_no: [{ required: true, message: `请选择所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      rules1: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        num: [
          { required: true, message: '数量不能为空' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
      },
      action: '',
      downloadUrl: 'template/实训耗材导入模版.xlsx',
      downloadName: '实训耗材导入模版.xlsx',
      btnTitle: '导入实训耗材数据',
      exportUrl: '',
      printHtml: '',
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/consume/import`;
    this.exportUrl = `${this.baseUrlt}api/consume/queryExport`;

    this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getParams');
    this.$store.dispatch('getTermms');
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() { },
  methods: {
    handleNumbeChange(id) {
      this.numberDialogVisible = true;
      this.ruleForm1.id = id;
    },
    async changeConsumeNumber() {
      let params = this.$until.easyDeepCopy(this.ruleForm1);
      let res = await this.$api.update.changeConsumeNumber(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '库存修改成功！',
        });
        this.ruleForm1 = {
          id: '',
          type: '',
          number: 0,
        };
        this.numberDialogVisible = false;
        this.handleQuery();
      }
    },
    async editTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm); 2;
      let res = await this.$api.instance.interfaceServer(`api/consume/batchUpdate`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '修改成功！',
        });
        this.ruleForm1 = {
          id: '',
          type: '',
          number: 0,
        };
        this.dialogVisible1 = false;
        this.handleQuery();
      }
    },
    handleEditRoom() {
      if (this.multipleSelection.length) {
        this.ruleForm2 = {
          id: this.multipleSelection.join(','),
          training_no: '',
          training_room: '',
        };
        this.dialogVisible1 = true;
      } else {
        this.$message({
          type: 'warning',
          center: true,
          message: '至少选择一条数据！',
        });
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false });
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleClassChange1(e) {
      this.ruleForm2.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createTarinRoom() {
      // console.log(this.total_price)
      // return
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.total_price = this.total_price;
      // 风险类型数组转为逗号分隔字符串提交
      if (params.fx_type && Array.isArray(params.fx_type)) {
        params.fx_type = params.fx_type.join(',');
      }
      // if (params.buy_at) {
      //   let timee = params.buy_at.getTime() / 1000;
      //   params.buy_at = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.createConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      params.total_price = this.total_price;
      // 风险类型数组转为逗号分隔字符串提交
      if (params.fx_type && Array.isArray(params.fx_type)) {
        params.fx_type = params.fx_type.join(',');
      }
      let res = await this.$api.creat.createConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getConsumeIntoList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time'] ,type='edit') {
      if (row.structure_1) {
        this.selectName = `${row.structure_1}${row.major ? ('-' + row.major) : ''}`;
      }
      this.type = type;
      this.title = type === 'view' ? '查看' : '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      // 风险类型回显：后端存为逗号分隔字符串，前端多选需要数组
      if (this.ruleForm.fx_type && typeof this.ruleForm.fx_type === 'string') {
        this.ruleForm.fx_type = this.ruleForm.fx_type.split(/[,，]/).map(s => s.trim()).filter(Boolean);
      }
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createTarinRoom();
          } else if (this.type == 'edit') {
            this.updateTarinRoom();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
